export default "__VITE_PUBLIC_ASSET__84cc4ca1__"